import { useTranslation } from 'react-i18next';

import Tooltip, { TooltipColors, TooltipSizes } from '@/shared/components/tooltip/Tooltip';

import AlertTriangleIcon from '@/features/timeGame/assets/images/alert-triangle.svg?react';

import '@/features/timeGame/styles/battery.scss';

interface Props {
	level: number;
	isTooltipOpen?: boolean;
}

const TOOLTIP_ANCHOR_ID = 'time-game-battery-tooltip';

const Battery = ({ level, isTooltipOpen = false }: Props) => {
	const { t } = useTranslation();

	// Determine the fill color based on the level
	const getActiveColor = (): string => {
		if (level >= 3) return '#69ca0f'; // slime/60
		if (level === 2) return '#ff970f'; // orange/60
		if (level === 1) return '#ea4e3c'; // red/60
		return '#000000'; // black for no level
	};

	const activeColor = getActiveColor();
	const inactiveColor = '#000000'; // black

	// Generate fill color for each path based on position
	const getPathFill = (position: number): string => {
		return position <= level ? activeColor : inactiveColor;
	};

	const isDepleted = level <= 0;

	return (
		<>
			<Tooltip
				place="top"
				title={t('time_game.battery.tooltip')}
				className="battery__tooltip"
				anchor={TOOLTIP_ANCHOR_ID}
				color={TooltipColors.LIGHT}
				size={TooltipSizes.LARGE}
				isOpen={isTooltipOpen}
				offset={18}
			/>
			<div id={TOOLTIP_ANCHOR_ID} className="battery">
				<svg width="158" height="58" viewBox="0 0 158 58" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="148" height="58" rx="8" fill="#260465" />
					<path d="M24 8H12V48H24V8Z" fill={getPathFill(1)} />
					<path d="M52 8H40V48H52V8Z" fill={getPathFill(2)} />
					<path d="M80 8H68V48H80V8Z" fill={getPathFill(3)} />
					<path d="M108 8H96V48H108V8Z" fill={getPathFill(4)} />
					<path d="M136 8H124V48H136V8Z" fill={getPathFill(5)} />
					<rect x="145" y="15" width="13" height="28" rx="4" fill="#260465" />
				</svg>
				{isDepleted ? (
					<span className="battery__alert" aria-label="Battery empty">
						<AlertTriangleIcon className="battery__alert-icon" />
					</span>
				) : null}
			</div>
		</>
	);
};

export default Battery;
